import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router';
import React from 'react';
import { AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN, AUTH0_SCOPE } from '../../core/config';

type Props = {
  children: React.ReactNode;
};

export const AuthProvider: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate();

  /**
   * After some issues with the silent login on Firefox, this seems to fix the issue. Firefox (and potentially other
   * Browsers) disable third party cookies by default, which breaks the silent login functionality. See this post for
   * more information: https://community.auth0.com/t/silent-authorization-not-working-after-login-signup/37114/6
   */
  return (
    <Auth0Provider
      useRefreshTokens // this fixes the problems with third party cookies
      cacheLocation="localstorage" // location for refreshTokens
      clientId={AUTH0_CLIENT_ID}
      domain={AUTH0_DOMAIN}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: AUTH0_AUDIENCE,
        scope: AUTH0_SCOPE,
      }}
      onRedirectCallback={() => {
        navigate(window.location.pathname);
      }}
    >
      {children}
    </Auth0Provider>
  );
};
